import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { useLang } from "../../context/LanguageContext";
import { SectionHeading } from "../motion/SectionHeading";
import { TurkeyMap } from "../TurkeyMap";
import { Reveal } from "../motion/Reveal";

export const RegionsPreview = ({ regions = [], projects = [] }) => {
  const { t, tc } = useLang();
  return (
    <section className="py-10 sm:py-14 bg-white" data-testid="regions-section">
      <div className="max-w-[1400px] mx-auto px-5 sm:px-8">
        <SectionHeading overline={t.regions.overline} title={t.regions.title} sub={t.regions.sub} center />
        <div className="grid lg:grid-cols-12 gap-10 items-center mt-8 sm:mt-10">
          <div className="lg:col-span-7">
            <Reveal>
              <div className="bg-lightgray rounded-3xl p-6 sm:p-10">
                <TurkeyMap regions={regions} projects={projects} />
              </div>
            </Reveal>
          </div>
          <div className="lg:col-span-5">
            <div className="grid gap-3">
              {regions.map((r, i) => (
                <Reveal key={r.slug} delay={i * 0.06}>
                  <Link
                    to={`/regions/${r.slug}`}
                    data-testid={`region-item-${r.slug}`}
                    className="group flex items-center justify-between gap-4 bg-white border border-border rounded-2xl px-6 py-5 hover:border-gold/40 hover:shadow-lg transition-all duration-400"
                  >
                    <div>
                      <h3 className="font-display text-xl text-charcoal group-hover:text-green transition-colors">{tc(r.name)}</h3>
                      <p className="text-charcoal/50 text-sm mt-0.5">{tc(r.tagline)}</p>
                    </div>
                    <span className="w-10 h-10 rounded-full bg-green/8 flex items-center justify-center group-hover:bg-green transition-colors duration-400 shrink-0">
                      <ArrowUpRight className="w-4 h-4 text-green group-hover:text-white transition-colors duration-400" />
                    </span>
                  </Link>
                </Reveal>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
